import { render, staticRenderFns } from "./stockcompare.vue?vue&type=template&id=a0c5ba5a"
import script from "./stockcompare.vue?vue&type=script&lang=js"
export * from "./stockcompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports